import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import certifiedCourseData from "../../../data/certifiedCoursesData";
import CertifiedDesign2CoursePage from "./design2/CertifiedDesign2CoursePage";
import { certifiedDesign2CourseData } from "./design2/certifiedDesign2CourseData";

function CertifiedCoursesTemplate() {
  const { certifiedCourse } = useParams();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  // Removed course page requested by the user.
  if (certifiedCourse === "project-management-associate") {
    return <h1>Course not found</h1>;
  }

  const pageData = certifiedDesign2CourseData[certifiedCourse];
  if (!pageData) {
    return <h1>Course not found</h1>;
  }

  const course = certifiedCourseData.find((c) => c.id === certifiedCourse);
  const overviewImageSrc = course?.backgroundImage || "";

  return (
    <CertifiedDesign2CoursePage
      pageData={pageData}
      overviewImageSrc={overviewImageSrc}
    />
  );
}

export default CertifiedCoursesTemplate;
